import React from 'react';
import {RawCheckboxDropdown} from './RawCheckboxDropdown';
import {FormikCheckboxDropdown} from './FormikCheckboxDropdown';
import {CheckboxDropdownWrapper, DropdownBtn} from './CheckboxDropdownStructure';
import {OptionList} from './CheckboxDropdownStyling';

function CheckboxDropdown({raw, ...props}) {
    if (raw) {
        return <RawCheckboxDropdown {...props} />;
    } else {
        return <FormikCheckboxDropdown {...props} />;
    }
}

CheckboxDropdown.Wrapper = CheckboxDropdownWrapper;
CheckboxDropdown.Input = DropdownBtn;
CheckboxDropdown.OptionList = OptionList;

export {CheckboxDropdown, CheckboxDropdownWrapper, DropdownBtn, OptionList};
